{
  "carrierLabel": "運送会社",
  "searchPlaceholder": "名前で検索",
  "selectAsCarrier": "「{name}」を運送会社として選択",
  "typeToSearch": "入力して会社を検索"
}
